/**
 * @author LiangYongJia, NonsenseError用于终止promise,捕获到该错误只需要继续reject或者throw即可
 */
export default class NonsenseError extends Error {
  constructor(...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NonsenseError);
    }
    this.name = 'NonsenseError';
  }
}
